/*
* @Author: GaoXiong
* @Date:   2018-11-27 15:00:00
* @Last Modified by:   GaoXiong
* @Last Modified time: 2018-11-27 15:00:00
*/

/**
 * 通用的PID配置
 * @type {[type]}
 */
const basePidConfig = require('../../../config/pid.config');

/*
 * 钱包收款 26
 */
basePidConfig.payWayList = [{
  text: '微信支付',
  value: '9',
  icon: '//www.huishoubao.com/www_fendi/new_PC/images/submit/weixin.svg'
}, {
  text: '支付宝',
  value: '2',
  icon: '//www.huishoubao.com/www_fendi/new_PC/images/submit/zhifubao.svg'
}];

basePidConfig.platform = 8;
basePidConfig.appSecret = 'b7cab12b2b81385dd2cccb8ce67e4998';
basePidConfig.isUseBJTime = true;
module.exports = basePidConfig;



// WEBPACK FOOTER //
// ./src/projects/hsbpc/config/default.js